import axios from 'axios';

export interface SessionTransferStudent {
  id: string;
  admissionNumber: string;
  scholarNumber?: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  currentClass: { id: string; name: string; sequenceOrder?: number };
  currentSection: { id: string; name: string };
  academicSession: { id: string; name: string };
  nextClassId?: string;
}

export interface PreviewSessionTransferParams {
  fromSessionId: string;
  classId: string;
  sectionId: string;
}

export interface ExecuteSessionTransferDto {
  fromSessionId: string;
  toSessionId: string;
  students: {
    studentId: string;
    newClassId: string;
    newSectionId: string;
  }[];
}

export interface SessionTransferResponse {
  studentsTransferred: number;
  studentsSkipped: number;
  failedStudents?: { studentId: string; reason: string }[];
}

export const sessionTransferApi = {
  preview: async (params: PreviewSessionTransferParams): Promise<SessionTransferStudent[]> => {
    const response = await axios.get('/scholar-register/session-transfer/preview', { params });
    return response.data;
  },

  execute: async (data: ExecuteSessionTransferDto): Promise<SessionTransferResponse> => {
    const response = await axios.post('/scholar-register/session-transfer', data);
    return response.data;
  },
};
